module.exports = __webpack_public_path__ + "static/media/logout.88293642.svg";